import React from 'react';
import classNames from 'classnames';
import SearchIcon from '@material-ui/icons/Search';
import ClearIcon from '@material-ui/icons/Clear';

import { Button, TextField } from '../../common';

export default ({
  styles,
  onSearchClick,
  onSearchChange,
  searchValue,
  onSearchClear
}) => (
  <div className={styles['search']}>
    <div className={styles['search__inputwrapper']}>
      <TextField
        placeholder="In Postfach suchen..."
        className={styles['search__input']}
        classNameInput={classNames(styles['search__input_focus'])}
        classNameNotched={classNames(styles['search__input-fieldset'])}
        startIcon={
          <SearchIcon className={styles['search__input-icon_search']} />
        }
        endIcon={
          searchValue ? (
            <ClearIcon className={styles['search__input-icon_clear']} />
          ) : null
        }
        onChange={onSearchChange}
        onEndIconClick={onSearchClear}
        value={searchValue}
      />
    </div>
    <div className={styles['search__buttonwrapper']}>
      <Button
        id="page.postbox.component.search.button"
        className={styles['search__button']}
        onClick={onSearchClick}
      >
        SUCHE
      </Button>
    </div>
  </div>
);
